(function() {
  'use strict';

  angular.module('app.maps')
    .factory('maps', maps);

  function maps($q, esriLoader, $templateCache, sessionService, PreviewPanel, Loader, panels, $rootScope, appConfig) {
    let queryString = '';
    let parcelPolyLayer,
      otcPtsLayer,
      dynLayer,
      auctionPtsLayer,
      auctionPolyLayer,
      otcPolyLayer,
      tractsLayer,
      allPubLayers = [],
      mapFilter = {},
      auctionDefaultFilter,
      otcDefaultFilter,
      parcelDefaultFilter,
      map,
      lettersQuery,
      parcelsRenderer,
      setTracts = true,
      selFeaturesGraphicsLayer;

    // setup the default sale type filter that will be applied to both tracts and parcels
    let saleDefaultFilter = ['ProposedSaleType = \'Auction\'', 'ProposedSaleType = \'Over the Counter\''];

    let service = {
      publicFilterProperties: publicFilterProperties,
      adminFilterProperties: adminFilterProperties,
      setActiveFilter: setActiveFilter,
      clearPublicFilter: clearPublicFilter,
      clearAdminFilter: clearAdminFilter,
      setInitialQuery: setInitialQuery,
      setPublicFilterLayers: setPublicFilterLayers,
      setAdminFilterLayers: setAdminFilterLayers,
      setTractQuery: setTractQuery,
      getFilterLayer: getFilterLayer,
      getQuery: getQuery,
      setPublicDefaultMapFilter: setPublicDefaultMapFilter,
      clearDefaultMapFilter: clearDefaultMapFilter,
      zoomToFeature: zoomToFeature,
      setMap: setMap,
      getTractsLayer: getTractsLayer,
      setTractsLayerDefQuery: setTractsLayerDefQuery,
      setLettersQuery: setLettersQuery,
      getParcelsRenderer: getParcelsRenderer,
      setParcelsRenderer: setParcelsRenderer,
      resetParcelsRenderer: resetParcelsRenderer,
      setSelGraphics: setSelGraphics,
      addSelectedGraphics: addSelectedGraphics,
      clearSelectedFeatures: clearSelectedFeatures,
      refreshDynamicLayer: refreshDynamicLayer,
      filterType: filterType
    };

    return service;

    function publicFilterProperties(query) {
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask',
        'esri/SpatialReference'
      ], function(
        Query,
        QueryTask,
        SpatialReference
      ) {
        let builtQuery = [];

        // combine and update the query strings based on the query passed into the function
        angular.extend(mapFilter, query);

        for (let eachQuery in mapFilter) {
          if (mapFilter[eachQuery] === '') {
            delete mapFilter[eachQuery];
          } else {
            builtQuery.push(mapFilter[eachQuery]);
          }
        }

        // set the query string for later retreval
        queryString = builtQuery.join(' AND ');

        // set the definition query on the layer first
        // set the query on the feature layer
        let filterString = '';
        if (builtQuery.length !== 0) {
          filterString = '(' + queryString + ') AND ';
        }
        // console.log(filterString);
        for (let i = 0; i < allPubLayers.length; i++) {
          let filterLayer = allPubLayers[i];
          // console.log(filterLayer);
          if (filterLayer.arcgisProps.title.indexOf('Auction') >= 0) {
            // console.log(filterString + auctionDefaultFilter);
            filterLayer.setDefinitionExpression(filterString + auctionDefaultFilter);
          } else if (filterLayer.arcgisProps.title.indexOf('Counter') >= 0) {
            // console.log(filterString + otcDefaultFilter);
            filterLayer.setDefinitionExpression(filterString + otcDefaultFilter);
          } else if (filterLayer.arcgisProps.title.indexOf('Parcel') >= 0) {
            console.log(filterString + parcelDefaultFilter + ' AND (' + saleDefaultFilter.join(' OR ') + ')');
            filterLayer.setDefinitionExpression(filterString + parcelDefaultFilter + ' AND (' + saleDefaultFilter.join(' OR ') + ')');
          }
        }

        // Loader.enable();
        if (builtQuery.length !== 0) {
          // contruct a query with the spatial extent of the map to limit the results
          let featuresQuery = new Query();
          featuresQuery.where = '(' + queryString + ') AND (' + saleDefaultFilter.join(' OR ') + ')';
          console.log('query: ', featuresQuery.where);
          featuresQuery.returnGeometry = false;
          featuresQuery.geometry = map.extent;
          featuresQuery.spatialRelationship = Query.SPATIAL_REL_INTERSECTS;
          featuresQuery.outSpatialReference = new SpatialReference(102100);
          // select the tracts
          tractsLayer.queryFeatures(featuresQuery, function(results) {
            let features = results.features;
            $rootScope.$broadcast('number-tracts', features.length);
            // open the preview panel
            Loader.disable();
            openPreviewPanel(features);
          });
        }
      });
    }

    function setActiveFilter(query) {
      let layerDefinitions = [];
      layerDefinitions[appConfig.getConfig().parcelsId] = '';
      if (query === true) {
        layerDefinitions[appConfig.getConfig().parcelsId] = 'TaxForfeitedStatus = \'Active\'';
        angular.extend(mapFilter, {
          'active': 'TaxForfeitedStatus = \'Active\''
        });
        $rootScope.$broadcast('clear-active', true);
      } else {
        $rootScope.$broadcast('clear-active', false);
        delete mapFilter.active;
      }
      // console.log('SET DEF QUERY = ', layerDefinitions[appConfig.getConfig().parcelsId]);
      if (dynLayer != null) {
        dynLayer.setLayerDefinitions(layerDefinitions);
      }
    }

    // second parameter indicates if the tracts should be set to the same query as the parcels
    function adminFilterProperties(query) {
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask',
        'esri/SpatialReference',
        'esri/graphic',
        'esri/graphicsUtils'
      ], function(
        Query,
        QueryTask,
        SpatialReference,
        Graphic,
        graphicsUtils
      ) {
        Loader.enable();
        let parcelsQuery = [];
        let tractsQuery = [];
        let parcelQueryString = '';

        // remove the active query if the string passed in already has the active part
        if (mapFilter.active != null && query.lastDate != null && query.lastDate.indexOf('TaxForfeitedStatus') >= 0) {
          delete mapFilter.active;
        }
        // combine and update the query strings based on the query passed into the function
        angular.extend(mapFilter, query);

        // setup the query for the parcels
        for (let eachQuery in mapFilter) {
          if (mapFilter[eachQuery] === '') {
            delete mapFilter[eachQuery];
          } else {
            parcelsQuery.push(mapFilter[eachQuery]);
          }
        }

        // setup the query for the tracts
        for (let eachQuery in mapFilter) {
          if (mapFilter[eachQuery] === '') {
            delete mapFilter[eachQuery];
          } else {
            if (eachQuery !== 'active') {
              tractsQuery.push(mapFilter[eachQuery]);
            }
          }
        }

        // set the query string for later retrieval
        queryString = parcelsQuery.join(' AND ');

        let layerDefinitions = [];
        // let featureQuery = '';
        layerDefinitions[0] = parcelsQuery.join(' AND ');
        parcelQueryString = parcelsQuery.join(' AND ');
        // if a query has been set from the letters query on dashboard apply that to the tracts layer
        // TODO: doesn't work when refreshing the app without being on the map first
        if (lettersQuery != null) {
          layerDefinitions[2] = lettersQuery;
          tractsLayer.setDefinitionExpression(lettersQuery);
          // query and zoom to these tracts
          let queryTask = new QueryTask(dynLayer.url + '/' + appConfig.getConfig().tractsId);
          let tractsQuery = new Query();
          tractsQuery.where = lettersQuery;
          tractsQuery.outFields = ['*'];
          tractsQuery.returnGeometry = true;
          tractsQuery.outSpatialReference = new SpatialReference(102100);
          queryTask.execute(tractsQuery, function(results) {
            let graphicArray = [];
            for (let i = 0; i < results.features.length; i++) {
              let oneGraphic = new Graphic(results.features[i].geometry, null, results.features[i].attributes, null);
              graphicArray.push(oneGraphic);
            }
            map.setExtent(graphicsUtils.graphicsExtent(graphicArray));
          });
        }
        // set the definition query on the dynamic map service when zoomed out
        // console.log('admin map parcels query: ', layerDefinitions[appConfig.getConfig().parcelsId]);
        if (dynLayer !== undefined) {
          let queryParcelsTask = new QueryTask(dynLayer.url + '/' + appConfig.getConfig().parcelsId);
          let parcelsQuery = new Query();
          parcelsQuery.where = parcelQueryString === '' ? parcelQueryString = '1=1' : parcelQueryString;
          parcelsQuery.outFields = ['*'];
          parcelsQuery.returnGeometry = true;
          parcelsQuery.outSpatialReference = new SpatialReference(102100);
          queryParcelsTask.execute(parcelsQuery, function(results) {
            if (results.features.length < 1000) {
              addSelectedGraphics(results.features);
            } else {
              clearSelectedFeatures();
            }
          });
        }
      });
    }

    function setTractQuery(setQuery) {
      setTracts = setQuery;
    }

    function clearPublicFilter() {
      // let today = new Date();
      for (let eachQuery in mapFilter) {
        // remove all of the queries from the object
        delete mapFilter[eachQuery];
      }

      // add only the default query to the string builder
      lettersQuery = null;
      closePreviewPanel();

      for (let i = 0; i < allPubLayers.length; i++) {
        let filterLayer = allPubLayers[i];
        // console.log(filterLayer);
        if (filterLayer.arcgisProps.title.indexOf('Auction') >= 0) {
          // console.log(filterString + auctionDefaultFilter);
          filterLayer.setDefinitionExpression(auctionDefaultFilter);
        } else if (filterLayer.arcgisProps.title.indexOf('Counter') >= 0) {
          // console.log(filterString + otcDefaultFilter);
          filterLayer.setDefinitionExpression(otcDefaultFilter);
        } else if (filterLayer.arcgisProps.title.indexOf('Parcel') >= 0) {
          // console.log(filterString + otcDefaultFilter);
          filterLayer.setDefinitionExpression(parcelDefaultFilter);
        }
      }

      // saleDefaultFilter = ['ProposedSaleType = \'Auction\'', 'ProposedSaleType = \'Over the Counter\''];
      //
      // // clear the selected features
      // parcelPolyLayer.clearSelection();
      // tractsLayer.clearSelection();
      // otcPtsLayer.clearSelection();
      // auctionPtsLayer.clearSelection();
      // //  console.log(saleDefaultFilter);
      // tractsLayer.setDefinitionExpression(saleDefaultFilter.join(' OR '));
      // otcPtsLayer.setDefinitionExpression(otcDefaultFilter);
      // auctionPtsLayer.setDefinitionExpression(auctionDefaultFilter + ' AND Last_LS_date > \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\'');
      // parcelPolyLayer.setDefinitionExpression(parcelDefaultFilter);
    }

    function clearAdminFilter() {
      // let today = new Date();
      for (let eachQuery in mapFilter) {
        // remove all of the queries from the object
        delete mapFilter[eachQuery];
      }

      // add only the default query to the string builder
      lettersQuery = null;
      closePreviewPanel();
      clearSelectedFeatures();
      if (dynLayer !== undefined) {
        dynLayer.setLayerDefinitions(null);
      }
      // clear the UI
      $rootScope.$broadcast('clear-search');
      $rootScope.$broadcast('set-query-indicator', {
        value: false
      });
    }


    function setInitialQuery(query) {
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask',
        'esri/SpatialReference'
      ], function(
        Query,
        QueryTask,
        SpatialReference
      ) {
        // Draws the map with new filter after load
        if (dynLayer !== undefined) {
          // if (_objSize(mapFilter) >= 1) {
          let queryParcelsTask = new QueryTask(dynLayer.url + '/' + appConfig.getConfig().parcelsId);
          let parcelsQuery = new Query();
          parcelsQuery.where = query;
          parcelsQuery.outFields = ['PIN'];
          parcelsQuery.returnGeometry = true;
          parcelsQuery.outSpatialReference = new SpatialReference(102100);
          queryParcelsTask.execute(parcelsQuery, function(results) {
            addSelectedGraphics(results.features);
          });
        }
      });
      // if (otcPtsLayer.type === undefined) {
      //   let layerDefinitions = [];
      //   layerDefinitions[0] = query;
      //   console.log('dynamic layer query: ', layerDefinitions);
      //   otcPtsLayer.setLayerDefinitions(layerDefinitions);
      // } else {
      //   otcPtsLayer.setDefinitionExpression(query);
      // }
      // // set the query on the feature layer
      // console.log('feature layer query: ', query);

      // tractsLayer.setDefinitionExpression(saleDefaultFilter.join(' OR '));
      // parcelPolyLayer.setDefinitionExpression(parcelDefaultFilter + ' AND (' + saleDefaultFilter.join(' OR ') + ')');
    }

    function getQuery() {
      return queryString;
    }

    function setPublicFilterLayers(auctionPtsLayerIn, otcPtsLayerIn, auctionPolyLayerIn, otcPolyLayerIn, parcelLayer, tractsIn) { // tractsIn
      tractsLayer = tractsIn;
      auctionPtsLayer = auctionPtsLayerIn;
      allPubLayers.push(auctionPtsLayer);
      otcPtsLayer = otcPtsLayerIn;
      allPubLayers.push(otcPtsLayer);
      auctionPolyLayer = auctionPolyLayerIn;
      allPubLayers.push(auctionPolyLayer);
      otcPolyLayer = otcPolyLayerIn;
      allPubLayers.push(otcPolyLayer);
      parcelPolyLayer = parcelLayer;
      allPubLayers.push(parcelPolyLayer);
    }

    function setAdminFilterLayers(tractsIn, dynLayerIn, polyLayerIn) {
      tractsLayer = tractsIn;
      dynLayer = dynLayerIn;
      parcelPolyLayer = polyLayerIn;
    }

    function getFilterLayer() {
      return parcelPolyLayer;
    }

    // saleDefaultFilterIn is coming from the tracts layer
    function setPublicDefaultMapFilter(auctionDefaultFilterIn, otcDefaultFilterIn, parcelDefaultFilterIn) {
      auctionDefaultFilter = auctionDefaultFilterIn;
      otcDefaultFilter = otcDefaultFilterIn;
      parcelDefaultFilter = parcelDefaultFilterIn;
    }

    function clearDefaultMapFilter() {
      mapFilter = {};
    }

    function zoomToFeature(objectid) {
      let queryById = {};
      queryById.where = 'OBJECTID = ' + objectid;
      tractsLayer.queryFeatures(queryById, function(results) {
        map.setExtent(results.features[0].geometry.getExtent(), true);
      });
    }

    function setMap(theMap) {
      map = theMap;
    }

    function getTractsLayer() {
      return tractsLayer;
    }

    function setTractsLayerDefQuery(type, vis) {
      let filterQuery = '';

      if (queryString !== '') {
        filterQuery = queryString + ' AND ';
      }
      if (type === 'Available over the counter - Points') {
        if (vis === false) {
          let queryIndex = saleDefaultFilter.indexOf("ProposedSaleType = 'Over the Counter'"); // jshint ignore:line
          saleDefaultFilter.splice(queryIndex, 1);
        } else {
          saleDefaultFilter.push('ProposedSaleType = \'Over the Counter\'');
        }
        if (saleDefaultFilter.length > 1) {
          filterQuery += saleDefaultFilter.join(' OR ');
        } else {
          filterQuery += saleDefaultFilter[0];
        }
        tractsLayer.setDefinitionExpression(filterQuery);
        parcelPolyLayer.setDefinitionExpression(filterQuery + ' AND ' + parcelDefaultFilter);
      } else {
        if (vis === false) {
          let queryIndex = saleDefaultFilter.indexOf("ProposedSaleType = 'Auction'"); // jshint ignore:line
          saleDefaultFilter.splice(queryIndex, 1);
        } else {
          saleDefaultFilter.push('ProposedSaleType = \'Auction\'');
        }
        if (saleDefaultFilter.length > 1) {
          filterQuery += saleDefaultFilter.join(' OR ');
        } else {
          filterQuery += saleDefaultFilter[0];
        }
        tractsLayer.setDefinitionExpression(filterQuery);
        parcelPolyLayer.setDefinitionExpression(filterQuery + ' AND ' + parcelDefaultFilter);
      }
    }

    function setLettersQuery(queryIn) {
      lettersQuery = queryIn;
    }

    function getParcelsRenderer() {
      return parcelsRenderer;
    }

    function setParcelsRenderer() {
      esriLoader.require([
        'esri/renderers/SimpleRenderer',
        'esri/symbols/SimpleFillSymbol',
        'esri/symbols/SimpleLineSymbol',
        'esri/Color'
      ], function(
        SimpleRenderer,
        SimpleFillSymbol,
        SimpleLineSymbol,
        Color
      ) {
        let rendererSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
            new Color([156, 0, 252, 0.75]), 4), new Color([0, 0, 0, 0.5])
        );

        parcelsRenderer = new SimpleRenderer(rendererSymbol);
      });
    }

    function setSelGraphics(graphicsLayer) {
      selFeaturesGraphicsLayer = graphicsLayer;
    }

    function addSelectedGraphics(features) {
      esriLoader.require([
        'esri/renderers/SimpleRenderer',
        'esri/symbols/SimpleFillSymbol',
        'esri/symbols/SimpleLineSymbol',
        'esri/Color',
        'esri/graphic'
      ], function(
        SimpleRenderer,
        SimpleFillSymbol,
        SimpleLineSymbol,
        Color,
        Graphic
      ) {
        clearSelectedFeatures();
        let selSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_NULL,
          new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
            new Color([255, 0, 0, 1]), 4) // 0, 204, 255 - blue
        );
        for (let i = 0; i < features.length; i++) {
          let newGraphic = new Graphic(features[i].geometry, selSymbol, features[i].attributes);
          selFeaturesGraphicsLayer.add(newGraphic);
        }
        Loader.disable();
      });
    }

    function clearSelectedFeatures() {
      if (selFeaturesGraphicsLayer != null) {
        selFeaturesGraphicsLayer.clear();
      }
    }

    function refreshDynamicLayer() {
      if (dynLayer != null) {
        dynLayer.refresh();
      }
    }

    function resetParcelsRenderer() {
      parcelsRenderer = null;
    }

    // helper sort function
    // function compare(property) {
    //   var sortOrder = 1;
    //   if (property[0] === '-') {
    //     sortOrder = -1;
    //     property = property.substr(1);
    //   }
    //   return function(a, b) {
    //     var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    //     return result * sortOrder;
    //   };
    // }

    function openPreviewPanel(parcels) {
      // open the side panel
      $rootScope.$broadcast('parcels-filtered', parcels);
      panels.open('resultsPanel');
    }

    function filterType(saleType, layerVisible, otcVisible, aucVisible) {
      // open the side panel
      $rootScope.$broadcast('parcels-typefiltered', saleType, layerVisible, otcVisible, aucVisible);
      panels.open('resultsPanel');
    }

    function closePreviewPanel() {
      console.log('closePreviewPanel');
      panels.close();
    }

    // function _objSize(obj) {
    //   var size = 0,
    //     key;
    //   for (key in obj) {
    //     if (obj.hasOwnProperty(key)) {
    //       size++;
    //     }
    //   }
    //   return size;
    // }

    // function _allPromises(features) {
    //   let promises = [];
    //   for (let i = 0; i < features.length; i++) {
    //     // query each property to get the images from the attachments
    //     promises.push(PreviewPanel.queryAttachments(features[i].attributes.OBJECTID, tractsLayer));
    //   }
    //   return $q.all(promises);
    // }
    //
    // function _refreshAll() {
    //   parcelPolyLayer.refresh();
    //   otcPtsLayer.refresh();
    //   auctionPtsLayer.refresh();
    //   tractsLayer.refresh();
    // }
  }
})();
